function cssFileWasLoaded (url, _document) {
  let headChildren = _document.head.childNodes
  for (let i = 0; i < headChildren.length; i++) {
    let child = headChildren[i]
    if (child.tagName === 'LINK' && child.href.endsWith(url)) {
      return true
    }
  }
  return false
}

export function loadCssFile (url, _document) {
  if (cssFileWasLoaded(url, _document)) {
    return Promise.resolve()
  } else {
    return new Promise(function (resolve, reject) {
      let link = _document.createElement('link')
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.href = url
      _document.head.appendChild(link)
      link.addEventListener('load', resolve)
      link.addEventListener('error', () => {
        reject(new Error(`Failed to load css file ${url}`))
      })
    })
  }
}
